import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useEffect, useRef } from 'react';
import { FaCog } from 'react-icons/fa';
import { Button } from '../button/Button';
const styles = {
    container: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '0.55px solid rgb(240, 240, 240)',
    }),
    leftContainer: css({
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        '& > button': {
            padding: '0 5px',
            minWidth: 'auto',
        },
    }),
    counterLabel: css({
        margin: 0,
        textAlign: 'right',
        lineHeight: '22px',
        whiteSpace: 'nowrap',
    }),
};
export function PanelHeader({ total, current, children, onClickSettings, }) {
    const labelRef = useRef(null);
    useEffect(() => {
        if (!labelRef.current)
            return;
        if (current !== undefined && total !== undefined) {
            labelRef.current.textContent = `${current} / ${total}`;
        }
        else if (current !== undefined) {
            labelRef.current.textContent = `[ ${current} ]`;
        }
        else if (total !== undefined) {
            labelRef.current.textContent = `[ ${total} ]`;
        }
    }, [current, total]);
    return (_jsxs("div", { css: styles.container, children: [_jsx("div", { css: styles.leftContainer, children: children }), _jsx("p", { ref: labelRef, css: styles.counterLabel }), onClickSettings && (_jsx(Button, { onClick: onClickSettings, color: { basic: 'black', hover: 'black' }, backgroundColor: { basic: 'white', hover: '#f7f7f7' }, children: _jsx(FaCog, {}) }))] }));
}
//# sourceMappingURL=PanelHeader.js.map